<div class="product-list-wrapper" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <!-- Async pipe with else for loading -->
    <ng-container
      *ngIf="personalSimulations$ | async as personalSimulations; else loading"
    >
      <ng-container *ngIf="personalSimulations.length > 0; else noProducts">
        <qai-item-grid gap="25px" minItemWidth="410px" repeatCount="auto-fill">
          <qai-product-tile
            *ngFor="let personalSim of personalSimulations"
            [title]="personalSim.moduleName"
            [description]="personalSim.description"
            [descriptionIcon]="'annotation-dots'"
            [ribbonIcon]="personalSim.ribbonIcon"
            [ribbonKind]="personalSim.ribbonKind || 'primary'"
          >
            <button
              type="button"
              qai-button
              kind="primary"
              size="small"
              qaiSlot="action"
              [disabled]="personalSim.sessionsCount === 0"
              (click)="viewSession(personalSim)"
            >
              {{ personalSim.buttonText }}
            </button>
          </qai-product-tile>
        </qai-item-grid>
      </ng-container>

      <ng-template #noProducts>
        <div class="no-products-container">
          <p>{{ "reportingV2.NO_PRODUCTS" | transloco }}</p>
        </div>
      </ng-template>
    </ng-container>

    <!-- Loading template -->
    <ng-template #loading>
      <div class="loading-container">
        <qai-loading
          [label]="'personalizedPractice.LOADING' | transloco"
          [size]="'medium'"
        ></qai-loading>
      </div>
    </ng-template>
  </qai-inner-wrap>
</div>
